import { render, staticRenderFns } from "./RegisterComplete.vue?vue&type=template&id=5994f83a"
import script from "./RegisterComplete.vue?vue&type=script&lang=js"
export * from "./RegisterComplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports